module.exports = __webpack_public_path__ + "img/index_bottom_wechat.7d146920.png";